import {StyleSheet} from 'react-native';
import {scaleFonts} from '@buncha/appStyles/style/font';

export const styles = StyleSheet.create({
  flex1: {
    flex: 1,
  },
  mainContainer: {
    marginHorizontal: 20,
    paddingBottom: 20,
  },
  headerSection: {
    marginVertical: 20,
    gap: 10,
  },
  divider: {
    marginVertical: 20,
  },
  bottomLeftBox: {
    flex: 1,
  },
  bottomRightBox: {
    flex: 1,
    alignSelf: 'flex-end',
    alignItems: 'flex-end',
  },
  bottomSkeletonLine1: {
    width: '85%',
    borderRadius: 5,
    height: scaleFonts(20),
    marginBottom: 20,
  },
  bottomSkeletonLine2: {
    width: '85%',
    borderRadius: 5,
    height: scaleFonts(10),
    marginBottom: 5,
  },
  bottomSkeletonLine3: {
    width: '100%',
    borderRadius: 5,
    height: scaleFonts(20),
  },
});
